import { $$t } from "@/i18n/i18n.js";
import globleConfig, { chinaAppName, ModuleOpenStateControl } from "@/config/config.js";
import { payOrder } from "@/api/api/apiCommon.js";
import message from "@/components/functionCallComponent/message/message.js";
import { isMobileDevice } from "./tools";
import ShowWxPayDialog from "@/components/wxPayDialog/wxPayDialog.js";
import ShowConfirmPayDialog from "@/components/confirmPayDialog/confirmPayDialog.js"

export const handlePayMoney = (
  { order_id, totalPrice, wechat_native_url },
  paySuccess,
  payFail,
) => {
  if (ModuleOpenStateControl.pay.openMobile && isMobileDevice()) {
    // 先记录当前页面可见状态
    let wasHidden = document.hidden;
    
    const handleVisibilityChange = () => {
      // 当页面从隐藏变为可见时执行
      if (!document.hidden && wasHidden) {
        // 移除监听（只执行一次）
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        
        ShowConfirmPayDialog({ orderId: order_id });
      }
      wasHidden = document.hidden;
    };

    // 添加页面可见性监听
    document.addEventListener('visibilitychange', handleVisibilityChange);
    
    // 跳转到支付页面
    window.location.href = wechat_native_url;
    if (isMobileDevice()) {
  
    }
  } else {
    ShowWxPayDialog({
      qrCode: wechat_native_url,
      orderId: order_id,
      totalPrice,
      paySuccess,
      payFail,
    });
  }
};